export default __webpack_public_path__ + "static/media/13.2e1990ed.jpg";